export const GET_RESERVE_LIST = "GET_RESERVE_LIST";
export const GET_RESERVE_LIST_SUCCESS = "GET_RESERVE_LIST_SUCCESS";
export const GET_RESERVE_LIST_ERROR = "GET_RESERVE_LIST_ERROR";

export const GET_VEHICLES_NO_RESERVE = "GET_VEHICLES_NO_RESERVE";
export const GET_VEHICLES_NO_RESERVE_SUCCESS = "GET_VEHICLES_NO_RESERVE_SUCCESS";
export const GET_VEHICLES_NO_RESERVE_ERROR = "GET_VEHICLES_NO_RESERVE_ERROR";